import moment from "moment";

import { ClickableTextItem } from "@/Common/Api/ClickableText/Dto/ClickableTextItem";
import { DisplayListUI } from "@/Common/Components/Collections/DisplayListUI";
import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import * as LocalOperations from "@/Common/Operations/operations.local";

interface IClickableTextFilterTabComponentPopupProps {
    allClickable: ClickableTextItem[];
    textListCallback: (textList: ClickableTextItem) => void;
    tabsName: string[];
    textList: ClickableTextItem[];
    isGroupMode?: boolean;
}

class ClickableTextFilterTabComponentState {
    public tabsName: SearchableItemModelT<string>[];
    public textList: SearchableItemModelT<ClickableTextItem>[];
    public clickableContent: string;
    public selectedModifiedOn: string;
    public tabContextContentItems: string[];
}

class ClickableTextFilterTabComponent extends React.Component<IClickableTextFilterTabComponentPopupProps, ClickableTextFilterTabComponentState> {
    constructor(props: IClickableTextFilterTabComponentPopupProps) {
        super(props);

        const initialState = new ClickableTextFilterTabComponentState();
        initialState.tabsName = props.tabsName != null ? props.tabsName.map(x => new SearchableItemModelT<string>(x, x, x)) : [];
        initialState.textList = [];
        initialState.clickableContent = "";
        initialState.selectedModifiedOn = null;
        initialState.tabContextContentItems = [];
        this.state = initialState;
    }

    public componentDidUpdate(prevProps: IClickableTextFilterTabComponentPopupProps): void {
        if (this.props.textList !== prevProps.textList || this.props.allClickable != prevProps.allClickable) {
            this.mutateState(s => {
                s.textList = this.props.textList != null ? this.props.textList.map(x => new SearchableItemModelT<ClickableTextItem>(x.TabName, x.ItemId, x, x.TabName)) : [];
                s.tabsName = this.props.tabsName != null ? this.props.tabsName.map(x => new SearchableItemModelT<string>(x, x, x)) : [];
                s.clickableContent = "";
                s.selectedModifiedOn = null;
            });
        }
    }

    public render(): JSX.Element {
        let self = this;
        return (
            <div>
                {/* tabs */}
                <div className="tab-content-clickableText">
                    <div style={{ width: "25%", float: "left", height: "415px" }}>
                        <div style={{ textAlign: "center", padding: "5px 0px", borderBottom: " solid 1px rgb(214, 209, 209)" }}>
                            <h5>{cacheStore.GetString("TabLabel")}</h5>
                        </div>
                        <DisplayListUI
                            items={self.state.tabsName ?? []}
                            classForListContainer="tabName-clickableText-results"
                            onSelectedItemCallback={item => self.onClickTabs(item.Value)}
                            includeSearchbox={true}
                            renderItem={item => (
                                <div style={self.hasTabName(item.Value) ? { fontWeight: "bold" } : {}}>{item.Value}</div>
                            )}
                            classForItem="displayList-search-item"
                        />
                    </div>

                    {/* versions */}

                    <div style={{ width: "25%", float: "left", height: "415px" }}>
                        <div style={{ textAlign: "center", padding: "5px 0px", borderBottom: " solid 1px rgb(214, 209, 209)" }}>
                            <h5>{cacheStore.GetString("versionLabel")}</h5>
                        </div>

                        <DisplayListUI
                            items={self.state.textList ?? []}
                            classForListContainer="tabName-clickableText-results"
                            onSelectedItemCallback={item => self.onClickVersions(item.Model)}
                            includeSearchbox={false}
                            renderItem={item => (
                                <div>
                                    <div style={self.hasModifiedOn(item.Model.ModifiedOn, item.Model.TabName) ? { textAlign: "center", fontWeight: "bold" } : { textAlign: "center" }}>
                                        {(item != null) && (
                                            moment(item.Model.ModifiedOn).format("YYYY-MM-DD hh:mm:ss")
                                        )}
                                    </div>
                                    <div />
                                    <div style={{ textAlign: "center" }}>
                                        {(item != null) && (
                                            item.Model.NbUser + " " + cacheStore.GetString("user(s)Label")
                                        )}
                                    </div>
                                </div>
                            )}
                            classForItem="displayList-search-item"
                        />
                    </div>

                    {/* Details */}
                    <div style={{ width: "50%", float: "left", height: "415px" }}>
                        <div style={{ textAlign: "center", padding: "5px 0px", borderBottom: " solid 1px rgb(214, 209, 209)" }}>
                            <h5>{cacheStore.GetString("DetailsLabel")}</h5>
                        </div>

                        {(self.state.clickableContent != null && self.state.clickableContent.length > 0) && (
                            <div className="tabName-clickableText-results" style={{ overflowY: "auto", border: "1px solid rgb(214, 209, 209)", marginTop: "50px" }}>
                                <div className="preview">
                                    <div className="preview-container">
                                        <div className="overflow-control" style={{ whiteSpace: "pre" }}>
                                            <ul className="clickable-text-list">
                                                {this.state.tabContextContentItems.map((s: string, idx: number) => (
                                                    <li key={idx + "___cli"} style={{ flexWrap: "wrap" }}>
                                                        <div className="flex-container" style={{ justifyContent: "flex-start", display: "flex", marginLeft: "5px" }}>
                                                            <div style={{ width: "10px" }}>
                                                                <span className="dot" />
                                                            </div>
                                                            <div style={{ width: "10px" }}>
                                                                {this.splitClickableTextItems(s).map((sp: string, idx2: number) => (
                                                                    <a key={"individual_link_" + idx2} style={{ marginRight: "5px", lineHeight: "15px", minHeight: "35px", marginBottom: "6px", textDecoration: "underline" }}>
                                                                        <span>{sp}</span>
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {(self.state.selectedModifiedOn != null && self.state.clickableContent.length == 0) && (
                            <div className="tabName-clickableText-results" style={{ overflowY: "auto", border: "1px solid rgb(214, 209, 209)", marginTop: "50px" }}>
                                <div className="pointer" style={{ textAlign: "center" }}>
                                    <span>{cacheStore.GetString("TextIsEmptyLabel")}</span>
                                </div>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        );
    }

    private mutateState(mutation: (s: ClickableTextFilterTabComponentState) => void, then: () => void = null): void {
        var s = new ClickableTextFilterTabComponentState();
        mutation(s);
        this.setState(s, then);
    }

    private onClickTabs(tabName: string): void {
        this.mutateState(
            s => {
                s.clickableContent = "";
                s.selectedModifiedOn = null;
                s.textList = [];
            },
            () => {
                if (this.props.isGroupMode)
                    sessionStore.dispatch(LocalOperations.AdministrationGroup.SelectDetailsOfClickableText, { SelectedItem: tabName });
                else
                    sessionStore.dispatch(LocalOperations.AdministrationUsers.SelectDetailsOfClickableText, { SelectedItem: tabName });
            }
        );
    }

    private onClickVersions(x: ClickableTextItem): void {
        let content = x.ClickableContent;
        this.mutateState(
            s => {
                s.clickableContent = x.ClickableContent;
                s.selectedModifiedOn = x.ModifiedOn;
                s.tabContextContentItems = this.parseClickableContent(content);
            },
            () => {
                if (x) this.props.textListCallback(x);
            }
        );
    }

    private hasTabName(tabName: string): boolean {
        if (this.props.allClickable == null) return false;
        return this.props.allClickable.some(x => x.TabName == tabName);
    }

    private hasModifiedOn(date: string, tabName: string): boolean {
        if (this.props.allClickable == null) return false;
        return this.props.allClickable.some(x => x.ModifiedOn == date && x.TabName == tabName);
    }

    private parseClickableContent(str: string): string[] {
        if (IsNullOrWhiteSpace(str))
            return [];

        let pattern = new RegExp("/\\*(((?!\\*/)[\\S\\s])*)\\*/", "g");

        let matchRanges: string[] = [];
        let result: RegExpExecArray = null;
        while ((result = pattern.exec(str)) !== null) {
            matchRanges.push(result[1]);
        }

        return matchRanges.filter(x => !IsNullOrWhiteSpace(x));
    }

    private splitClickableTextItems(txt: string): string[] {
        if (IsNullOrWhiteSpace(txt))
            return [];

        return txt.split(";").filter(s => !IsNullOrWhiteSpace(s));
    }
}

export { ClickableTextFilterTabComponent };
